import { ContactPerson } from '../../../../../types/contactPerson'

interface UpdateEditedContactToPrimaryProps {
  contacts: ContactPerson[]
  editedIndex: number
  newPrimaryContactData: ContactPerson
}

export const updateEditedContactToPrimary = ({
  contacts,
  editedIndex,
  newPrimaryContactData,
}: UpdateEditedContactToPrimaryProps): ContactPerson[] => {
  const updatedContacts = [...contacts]

  updatedContacts[editedIndex] = {
    ...updatedContacts[editedIndex],
    ...newPrimaryContactData,
  }

  return updatedContacts
}
